import type React from "react";
import { useState } from "react";
import type { ActiveTab } from "./SalesBoardPage";
import { SalesBoardPage } from "./SalesBoardPage";

/**
 * 営業ボードページのコンテナコンポーネント
 * @return {React.ReactElement} 営業ボードページ
 */
const SalesBoardPageContainer: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ActiveTab>("pipeline");

  return <SalesBoardPage activeTab={activeTab} onTabChange={setActiveTab} />;
};

export default SalesBoardPageContainer;
